export default __webpack_public_path__ + "static/media/Group 127.47a0fd64.png";